import styled from "styled-components"

export const ContentRelatedContentDIV = styled.div`
  background: var(--color--clay-100);
  border-radius: var(--border-radius--M);
  margin: var(--spacing--S) 0 var(--spacing--M);
  padding: var(--spacing--base-1-5) var(--spacing--base-2-25);
  position: relative;
  z-index: 2;

  h6 {
    margin-top: 0;
    margin-bottom: var(--spacing--XS);
  }

  && .Cards {
    margin-bottom: 0;

    .flex {
      gap: var(--spacing--XS);
    }
  }

  && .Card {
    border-bottom: 0;
    padding-bottom: 0;

    h5 {
      font-family: var(--font-family--sans);
      font-feature-settings: var(--font-family--sans--font-feature-settings);
      font-weight: var(--font-weight--medium);
      font-size: var(--font-size--L);
    }
  }

  &.is-condensed {
    p,
    span {
      margin: 0;
      line-height: 1.8;
    }

    a {
      color: var(--color--text-dark);
      text-decoration: underline;
      text-decoration-color: var(--color--text-light);
      text-decoration-thickness: 1px;
      text-underline-offset: 0.375em;

      &:hover {
        color: var(--color--action-hovered);
        text-decoration-color: var(--color--action-default);
      }
    }
  }
`
